import ts from "typescript";
import { TokenPayload } from "../../types/constants.types";
import { jwtDecode } from "jwt-decode";

const JWT_LOCAL_STORE = process.env.REACT_APP_JWT_LOCAL_STORE;

export const getToken = (tokenName: string): TokenPayload => {
	try {
		var _token = "";
		if (JWT_LOCAL_STORE) _token = localStorage.getItem(tokenName) || "";
		if (!_token || _token.split('.').length < 3) {
			return {} as TokenPayload;
		}
		const decodedToken: TokenPayload = jwtDecode(_token);
		decodedToken.token = _token;
		return decodedToken;
	} catch (err) {
		console.log(err);
		return {} as TokenPayload;
	}
};

export const setToken = (name: string, token: string): boolean => {
	try {
		if (JWT_LOCAL_STORE) localStorage.setItem(name, token);
		return true;
	} catch (err) {
		return false;
	}
};

export const validateToken = (token: string): boolean => {
	return true;
};

export const decodeToken = (token: string): TokenPayload => {
	try {
		if (!token || token.split('.').length < 3) {
			return {} as TokenPayload;
		}
		const decodedToken: TokenPayload = jwtDecode(token);
		decodedToken.token = token;
		return decodedToken;
	} catch (err) {
		console.log(err);
		return {} as TokenPayload;
	}
};
